import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';
import ProcessFormField from './ProcessFormField';
import PropTypes from 'prop-types';


const useFieldSets = (formFields) => {

    const [fieldSets, setFieldSets] = useState([]);

    useEffect(()=>{

        if (Array.isArray(formFields)) {

            const sectionFieldSets = []
            
            const sectionIndices = formFields
                .map((field, index)=> (field.type === 'section' && index) )
                .filter(index => index !== false);
    
            if (sectionIndices.length) {
                for (var i = 0; i < sectionIndices.length; i++){
                    sectionFieldSets.push(formFields.slice(sectionIndices[i], sectionIndices[i + 1]))
                }
                setFieldSets(sectionFieldSets ?? []);
            }
        }
        
    },[])

    return fieldSets;
}


const ProcessFieldSets = ({
    dispatch, formState, formFields
}) => {

    const fieldSets = useFieldSets(formFields);

    return (
        <>
            {/* <pre>{JSON.stringify(fieldSets, null, 2)}</pre> */}

            {(Array.isArray(fieldSets) && fieldSets.length > 0) ?  Array.from(fieldSets).map((fieldSet) => (
                <fieldset tw="border-0">
                    {fieldSet.map(field => (
                        <ProcessFormField
                            field={field}
                            value={formState[field.id]}
                            dispatch={dispatch}
                            formState={formState}
                        />
                    ))}
                </fieldset>
            )) : formFields.map(field => (
                <ProcessFormField
                    field={field}
                    value={formState[field.id]}
                    dispatch={dispatch}
                    formState={formState}
                />
            ))}
        </>
    )
}

ProcessFieldSets.propTypes = ({
    dispatch: PropTypes.func.isRequired,
    formState: PropTypes.object.isRequired,
    formFields: PropTypes.array.isRequired,
})

export default ProcessFieldSets;